export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";